const noteRules = [
  { match: /coffee|cocoa|chocolate/, label: 'Coffee', icon: 'mdi-coffee-outline' },
  { match: /vanilla|tonka/, label: 'Vanilla', icon: 'mdi-ice-cream' },
  { match: /cinnamon|cardamom|saffron|pepper|spice|spicy|ginger/, label: 'Spice', icon: 'mdi-chili-mild-outline' },
  { match: /mint|lavender|sage/, label: 'Herbal', icon: 'mdi-leaf' },
  { match: /rose|jasmine|peony|violet|lotus|blossom|floral|florals/, label: 'Floral', icon: 'mdi-flower-outline' },
  { match: /bergamot|citrus|mandarin|orange|grapefruit|yuzu|lemon|apple|pineapple|pear|peach|lychee|raspberry|blackcurrant|passionfruit|pomegranate|fruit/, label: 'Fruit', icon: 'mdi-fruit-citrus-outline' },
  { match: /oud/, label: 'Oud', icon: 'mdi-pine-tree' },
  { match: /leather/, label: 'Leather', icon: 'mdi-wallet-outline' },
  { match: /tobacco|incense|smoky/, label: 'Smoke', icon: 'mdi-smoke' },
  { match: /amber|ambergris|musk/, label: 'Amber', icon: 'mdi-diamond-stone' },
  { match: /cedar|sandalwood|birch|vetiver|patchouli|wood|woody|driftwood|chestnut|coconut/, label: 'Wood', icon: 'mdi-tree-outline' },
  { match: /aquatic|marine|sea salt|ocean/, label: 'Aquatic', icon: 'mdi-waves' },
  { match: /caramel|praline|honey|candy/, label: 'Sweet', icon: 'mdi-candy-outline' }
]

export function getNoteChips(notesText = '') {
  const text = notesText.toLowerCase()
  const chips = []

  for (const rule of noteRules) {
    if (rule.match.test(text) && !chips.some(chip => chip.label === rule.label)) {
      chips.push({ label: rule.label, icon: rule.icon })
    }
    if (chips.length === 3) break
  }

  if (!chips.length) {
    chips.push({ label: 'Signature', icon: 'mdi-bottle-tonic-outline' })
  }

  return chips
}
